// import React, { useState } from 'react'
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Dashboard
import Home from "./components/Dashboard/Home";
import FranchiseRestaurants from "./components/Dashboard/FranchiseRestaurants";
import FranchiseProfile from "./components/Franchise/FranchiseProfile";
import DashboardArchives from "./components/Dashboard/DashboardArchives";
import Orders from "./components/Dashboard/Orders";
import OrdersBoard from "./components/Dashboard/OrdersBoard";
import OrderId from "./components/Dashboard/OrderId";
import GeneralCustomers from "./components/Dashboard/GeneralCustomers";
import Analytics from "./components/Dashboard/Analytics";
import Reviews from "./components/Dashboard/Reviews";
import Task from "./components/Dashboard/Task";
import GoogleUsers from "./components/Dashboard/GoogleUsers";
import RestaurantUsers from "./components/Dashboard/RestaurantUsers";
import AddRestaurantUser from "./components/Dashboard/AddRestaurantUser";
import RestaurantPermissionGuard from "./components/Restaurant/RestaurantPermissionGuard";
import Plans from "./components/Plans/Plans";
import SubscriptionGate from "./components/Plans/SubscriptionGate";
import { PlanAccessProvider } from "./components/Plans/PlanAccess";

//CMS
import Content from "./components/Cms/Content";
import Menu from "./components/Cms/Menu";
import EmailTemplate from "./components/Cms/EmailTemplate";
import Blog from "./components/Cms/Blog";
import ContentAdd from "./components/Cms/ContentAdd";
import AddMail from "./components/Cms/AddMail";
import AddBlog from "./components/Cms/AddBlog";
import BlogCategory from "./components/Cms/BlogCategory";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import StripeRefresh from "./components/AppsMenu/AppProfile/StripeRefresh";
import StripeReturn from "./components/AppsMenu/AppProfile/StripeReturn";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import EcomCustomers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import RechartJs from "./components/charts/rechart";
import ChartJs from "./components/charts/Chartjs";
// import Chartist from './components/charts/chartist'
import SparklineChart from "./components/charts/Sparkline";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import Nestable from "./components/PluginsMenu/Nestable/Nestable";
import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

/// Widget
import Widget from "./pages/Widget";

/// Table
import DataTable from "./components/table/DataTable";
import BootstrapTable from "./components/table/BootstrapTable";
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";

/// Form

import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages
// import Registration from './pages/Registration'
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Todo from "./pages/Todo";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";
import Restaurants from "./components/Dashboard/Restaurants";
import { AddRestaurant } from "./components/Dashboard/AddRestaurant";
import RestaurantOverview from "./components/Dashboard/RestaurantOverview";
import ProductsGrid from "./components/Dashboard/ProductsGrid";
import ProductDetails from "./components/Dashboard/ProductDetails";
import ProductEditing from "./components/Dashboard/ProductEditing";
import CreateProduct from "./components/Dashboard/CreateProduct";
import AddProduct from "./components/Dashboard/AddProduct";
import ProductsGridHistory from "./components/Dashboard/ProductGridHistory";
import CategoryGrid from "./components/Dashboard/CategoryGrid";
import AddCategory from "./components/Dashboard/AddCategory";
import CategoryGridHistory from "./components/Dashboard/CategoryGridHistory";
import CategoryDetails from "./components/Dashboard/CategoryDetails";
import CategoryEditing from "./components/Dashboard/CategoryEditing";
import ItemsGrid from "./components/Dashboard/ItemsGrid";
import AddItem from "./components/Dashboard/AddItem";
import ItemDetails from "./components/Dashboard/ItemDetails";
import EditItem from "./components/Dashboard/EditItem";
import ItemsGridHistory from "./components/Dashboard/ItemsGridHistory";
import ChoicesGrid from "./components/Dashboard/ChoicesGrid";
import AddChoice from "./components/Dashboard/AddChoice";
import ChoiceDetails from "./components/Dashboard/ChoiceDetails";
import EditChoice from "./components/Dashboard/EditChoice";
import ChoiceGridHistory from "./components/Dashboard/ChoiceGridHistory";
import EditMenu from "./components/Cms/EditMenu";
import AddMenu from "./components/Cms/addMenu";
import ManageMenu from "./components/Cms/ManageMenu";
import MenuGridHistory from "./components/Dashboard/MenuGridHistory";
import Calls from "./components/Dashboard/Calls";
import TestIpact from "./components/Dashboard/TestIpact";
import GenerateQRcode from "./components/AppsMenu/Qrcode/GenerateQRcode";
import StripeAccount from "./components/AppsMenu/AppProfile/StripeAccount";
import MenuDetails from "./components/Cms/menuDetails";
import SupportList from "./components/Support/SupportList";
import MySupportRequests from "./components/Support/MySupportRequests";
import SupportTicketViewPage from "./components/Support/SupportTicketViewPage.jsx";
import ArchivedSupportRequests from "./components/Support/ArchivedSupportRequests";
import SupportFloatingButton from "./components/Support/SupportFloatingButton";
import ClientReclamations from "./components/Dashboard/ClientReclamations";
import ArchivedClientReclamations from "./components/Dashboard/ArchivedClientReclamations";
import LostFound from "./components/Dashboard/LostFound";
import ArchivedLostFound from "./components/Dashboard/ArchivedLostFound";
import Reservations from "./components/Dashboard/Reservations";
import AdminHistory from "./components/Dashboard/AdminHistory";
import ArchivedAdminHistory from "./components/Dashboard/ArchivedAdminHistory";
import ArchivedEventReservations from "./components/Dashboard/ArchivedEventReservations";
import ArchivedTableReservations from "./components/Dashboard/ArchivedTableReservations";
import Subcategories from "./components/AppsMenu/Shop/Subcategory/Subgategories";
import SubcategoriesGrid from "./components/Dashboard/SubcategoriesGrid";
import AddSubcategory from "./components/Dashboard/AddSubcategory";
import EditSubcategory from "./components/Dashboard/EditSubcategory";
import SubcategoryDetails from "./components/Dashboard/SubcategoryDetails";
import SubcategoriesGridHistory from "./components/Dashboard/SubcategoriesGridHistory";
import SubcategoriesHistory from "./components/Dashboard/SubcategoriesHistory";

import AddNewProduct from "../jsx/components/Dashboard/AddNewProduct";
import StartNowWizard from "./components/Setup/StartNowWizard/StartNowWizard";
import Events from "./components/Dashboard/Events";
import EventReservations from "./components/Dashboard/EventReservations";
import Clients from "./components/Dashboard/Clients";
import ClientDetail from "./components/Dashboard/ClientDetail";
import ArchivedClients from "./components/Dashboard/ArchivedClients";
import ArchivedPlanFloorSetups from "./components/Dashboard/ArchivedPlanFloorSetups";
import OnboardingTutorial from "./components/Onboarding/OnboardingTutorial";
import InteractiveTourSpotlight from "./components/Onboarding/InteractiveTourSpotlight";
import AdvancedWelcomeTour from "./components/Onboarding/AdvancedWelcomeTour";
import AdvancedWelcomeTourLauncher from "./components/Onboarding/AdvancedWelcomeTourLauncher";
import { OnboardingTourProvider } from "../context/OnboardingTourContext";
import { AdvancedWelcomeTourProvider } from "../context/AdvancedWelcomeTourContext";
import FranchiseRouteGuard from "./components/Franchise/FranchiseRouteGuard";
import FranchiseImpersonationBanner from "./components/Franchise/FranchiseImpersonationBanner";
import { isFranchisePortalSession } from "../utils/franchiseSession";
import "../assets/css/onboarding-tutorial.css";
import "../assets/css/interactive-tour.css";
import Notifications from "./components/Dashboard/Notifications";

const Markup = () => {
  const allroutes = [
    /// Dashboard
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "plans", component: <Plans /> },
    { url: "franchise-restaurants", component: <FranchiseRestaurants /> },
    { url: "franchise-profile", component: <FranchiseProfile /> },

    { url: "orders", component: <Orders /> },
    { url: "notifications", component: <Notifications /> },
    { url: "orders-board", component: <OrdersBoard /> },
    { url: "reservations", component: <Reservations /> },
    { url: "clients", component: <Clients /> },
    { url: "clients/profile", component: <ClientDetail /> },
    { url: "clients/:clientId", component: <ClientDetail /> },
    { url: "archived-clients", component: <ArchivedClients /> },
    { url: "archived-plan-floor-setups", component: <ArchivedPlanFloorSetups /> },
    { url: "admin-history", component: <AdminHistory /> },
    { url: "archived-admin-history", component: <ArchivedAdminHistory /> },
    { url: "archived-table-reservations", component: <ArchivedTableReservations /> },
    { url: "archived-event-reservations", component: <ArchivedEventReservations /> },
    { url: "Order-id", component: <OrderId /> },
    { url: "client-reclamations", component: <ClientReclamations /> },
    { url: "archived-client-reclamations", component: <ArchivedClientReclamations /> },
    { url: "lost-found", component: <LostFound /> },
    { url: "archived-lost-found", component: <ArchivedLostFound /> },
    { url: "general-customers", component: <GeneralCustomers /> },
    { url: "restaurants", component: <Restaurants /> },
    { url: "create-brand", component: <AddRestaurant /> },
    { url: ":nameRes", component: <RestaurantOverview /> },
    { url: "analytics", component: <Analytics /> },
    { url: "review", component: <Reviews /> },
    { url: "task", component: <Task /> },

    /// Kitchen
    { url: "products", component: <ProductsGrid /> },
    { url: "create-product", component: <CreateProduct /> },
    { url: "add-product", component: <AddProduct /> },
    { url: "add-new-product", component: <AddNewProduct /> },
    { url: "product-sheet/:id", component: <ProductDetails /> },
    { url: "edit-product/:id", component: <ProductEditing /> },

    { url: "categories", component: <CategoryGrid /> },
    { url: "add-category", component: <AddCategory /> },
    { url: "category-details/:id", component: <CategoryDetails /> },
    { url: "edit-category/:id", component: <CategoryEditing /> },
    { url: "subcategoriesList", component: <SubcategoriesGrid /> },
    { url: "subcategories", component: <Subcategories /> },
    { url: "add-subcategory", component: <AddSubcategory /> },
    { url: "subcategory-details/:id", component: <SubcategoryDetails /> },
    { url: "edit-subcategory/:id", component: <EditSubcategory /> },
    { url: "start-now", component: <StartNowWizard /> },
    { url: "events", component: <Events /> },
    { url: "events/:eventId/reservations", component: <EventReservations /> },
    {
      url: "archived-events",
      component: <Events archived title={undefined} />,
    },
    {
      url: "subcategoriesList-history",
      component: <SubcategoriesGridHistory />,
    },
    { url: "subcategories-history", component: <SubcategoriesHistory /> },

    { url: "items", component: <ItemsGrid /> },
    { url: "add-item", component: <AddItem /> },
    { url: "item-details/:id", component: <ItemDetails /> },
    { url: "edit-item/:id", component: <EditItem /> },

    { url: "choices", component: <ChoicesGrid /> },
    { url: "add-choice", component: <AddChoice /> },
    { url: "choice-details/:id", component: <ChoiceDetails /> },
    { url: "edit-choice/:id", component: <EditChoice /> },

    // History

    { url: "menu-history", component: <MenuGridHistory /> },
    { url: "products-history", component: <ProductsGridHistory /> },
    { url: "categories-history", component: <CategoryGridHistory /> },
    { url: "items-history", component: <ItemsGridHistory /> },
    { url: "choices-history", component: <ChoiceGridHistory /> },
    { url: "dashboard-archives", component: <DashboardArchives /> },
    { url: "calls", component: <Calls /> },
    { url: "google-users", component: <GoogleUsers /> },
    { url: "restaurant-users", component: <RestaurantUsers /> },
    { url: "add-restaurant-user", component: <AddRestaurantUser /> },

    //Cms
    { url: "content", component: <Content /> },
    { url: "menu", component: <Menu /> },
    { url: "email-template", component: <EmailTemplate /> },
    { url: "blog", component: <Blog /> },
    { url: "add-content", component: <ContentAdd /> },
    { url: "add-email", component: <AddMail /> },
    { url: "add-blog", component: <AddBlog /> },
    { url: "blog-category", component: <BlogCategory /> },
    { url: "add-menu", component: <AddMenu /> },
    { url: "edit-menu/:id", component: <EditMenu /> },
    { url: "manage-menu/:id", component: <ManageMenu /> },
    { url: "menu-details/:id", component: <MenuDetails /> },

    /// Apps
    { url: "app-profile", component: <AppProfile /> },
    { url: "post-details", component: <PostDetails /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },
    { url: "app-qrcode", component: <GenerateQRcode /> },
    { url: "/app-profile/stripe/return", component: <StripeReturn /> },
    { url: "/stripe/refresh", component: <StripeRefresh /> },
    { url: "/stripe-account", component: <StripeAccount /> },
    /// Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },

    /// Bootstrap
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },

    /// Plugin
    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-nestable", component: <Nestable /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-noui-slider", component: <MainNouiSlider /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },

    /// Widget
    { url: "widget-basic", component: <Widget /> },

    /// Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-customers", component: <EcomCustomers /> },

    /// Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },

    /// table
    { url: "table-datatable-basic", component: <DataTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },
    { url: "table-filtering", component: <FilteringTable /> },
    { url: "table-sorting", component: <SortingTable /> },
    /// pages

    { url: "todo", component: <Todo /> },
    { url: "support", component: <SupportList /> },
    { url: "my-support-requests", component: <MySupportRequests /> },
    { url: "my-support-requests/:ticketId", component: <SupportTicketViewPage /> },
    { url: "archived-support-requests", component: <ArchivedSupportRequests /> },
    { url: "test/ipact", component: <TestIpact /> },
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};
function MainLayout() {
  const franchisePortal = isFranchisePortalSession();

  return (
    <PlanAccessProvider>
    <OnboardingTourProvider>
      <AdvancedWelcomeTourProvider>
      <FranchiseRouteGuard>
      <div
        id="main-wrapper"
        className="show"
      >
        <Nav />
        <FranchiseImpersonationBanner />
        {!franchisePortal ? (
          <>
            <OnboardingTutorial />
            <InteractiveTourSpotlight />
            <AdvancedWelcomeTourLauncher />
            <AdvancedWelcomeTour />
          </>
        ) : null}
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 45 }}
        >
          <div className="container-fluid">
            <RestaurantPermissionGuard>
              <SubscriptionGate>
                <Outlet />
              </SubscriptionGate>
            </RestaurantPermissionGuard>
          </div>
        </div>
        <Footer />
        {!franchisePortal ? <SupportFloatingButton /> : null}
      </div>
      </FranchiseRouteGuard>
      </AdvancedWelcomeTourProvider>
    </OnboardingTourProvider>
    </PlanAccessProvider>
  );
}

export default Markup;
